var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/IssueAnswer.ts";
import * as t from 'io-ts';
export var IssueAnswer;
(function (_IssueAnswer) {
  var type = 'IssueAnswer';
  var StatusEnum;
  (function (StatusEnum) {
    StatusEnum["DECLINED"] = "DECLINED";
    StatusEnum["PENDING"] = "PENDING";
    StatusEnum["ACCEPTED"] = "ACCEPTED";
    StatusEnum["DELETED"] = "DELETED";
  })(StatusEnum || (StatusEnum = {}));
  _IssueAnswer.StatusEnum = StatusEnum;
  var Status = _IssueAnswer.Status = t.union([t.literal(StatusEnum.DECLINED), t.literal(StatusEnum.PENDING), t.literal(StatusEnum.ACCEPTED), t.literal(StatusEnum.DELETED)]);
  var io = _IssueAnswer.io = t.type({
    type: t.literal(type),
    description: t.string,
    id: t.number,
    authorId: t.string,
    createdAt: t.string,
    status: Status
  });
})(IssueAnswer || (IssueAnswer = {}));